export const styles = {
    modalContent: {
        p: 0,
        pt: 6,
        px: { base: 4, md: 10.4 },
        pl: { base: 4, md: 6 },
        maxW: { base: "100%", md: "574px" },
        gap: 0,
        display: "flex",
        flexDirection: "column" as const,
        h: { base: "100dvh", md: "90vh" },
        maxH: { base: "100dvh", md: "90vh" },
    },
    heading: {
        mb: 6,
        flexShrink: 0,
    },
    modalBody: {
        flex: 1,
        overflowY: "auto",
        pb: { base: "100px", md: 0 },
    },
    backButtonContainer: {
        position: { base: "fixed", md: "relative" },
        bottom: { base: 0, md: "auto" },
        left: { base: 0, md: "auto" },
        right: { base: 0, md: "auto" },
        flexShrink: 0,
        bg: "white",
        py: { base: 4, md: "21px" },
        px: { base: 4, md: 6 },
        ml: { base: 0, md: -6 },
        mr: { base: 0, md: -10.4 },
        mt: { base: 0, md: "auto" },
        mb: { base: 0, md: -6 },
        backdropFilter: "blur(7.5px)",
        boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.1)",
        zIndex: 10,
    },
    backButton: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 3,
        w: "100%",
        h: "56px",
        px: 4,
        border: "1px solid",
        borderColor: "black",
        bg: "white",
        cursor: "pointer",
        _hover: {
            bg: "gray.50",
        },
    },
    backButtonText: {
        fontWeight: "bold",
        fontSize: "md",
        letterSpacing: "0.8px",
    },
};
